import { create } from 'zustand';
import { UserConfig } from '@share/domain';

interface ConfigState {
  config: UserConfig;
  updateConfig: (updates: Partial<UserConfig>) => void;
  setConfig: (config: UserConfig) => void;
}

const DEFAULT_CONFIG: UserConfig = {
  theme: 'light',
  downloadLocation: 'Downloads/Share',
  username: 'Anonymous Peer',
  notificationsEnabled: true,
};

export const useConfigStore = create<ConfigState>((set) => ({
  config: DEFAULT_CONFIG,
  updateConfig: (updates) =>
    set((state) => ({
      config: { ...state.config, ...updates },
    })),
  setConfig: (config) => set({ config }),
}));
